"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getIAMUXBaseAddress = getIAMUXBaseAddress;
exports.getIAMUXRequestOptions = exports.getUrlForApp = exports.getIAMUXTermsOfUseUrl = exports.getIAMUXChangePasswordUrl = exports.getIAMUXAppsUrl = exports.getIAMUXGroupsUrl = exports.getIAMUXProfileUrl = exports.AppKeys = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var _determineEnvironment = require("./determineEnvironment");

var AppKeys;
exports.AppKeys = AppKeys;

(function (AppKeys) {
  AppKeys["apps"] = "myApps";
  AppKeys["access"] = "myAccess";
  AppKeys["groups"] = "myGroups";
  AppKeys["account"] = "myAccount";
  AppKeys["signins"] = "mySignins";
  AppKeys["convergedUXV2"] = "convergedUXV2";
  AppKeys["staff"] = "myStaff";
})(AppKeys || (exports.AppKeys = AppKeys = {}));

var getIAMUXProfileUrl = function getIAMUXProfileUrl(params) {
  var baseAddress = getIAMUXBaseAddress(params);
  baseAddress.pathname = '/profile';
  return baseAddress.toString();
};

exports.getIAMUXProfileUrl = getIAMUXProfileUrl;

var getIAMUXGroupsUrl = function getIAMUXGroupsUrl(params) {
  var baseAddress = getIAMUXBaseAddress(params);
  baseAddress.pathname = '/redirect/groups';
  return baseAddress.toString();
};

exports.getIAMUXGroupsUrl = getIAMUXGroupsUrl;

var getIAMUXAppsUrl = function getIAMUXAppsUrl(params) {
  var baseAddress = getIAMUXBaseAddress(params);
  baseAddress.pathname = '/r';
  baseAddress.hash = '/applications';
  return baseAddress.toString();
};

exports.getIAMUXAppsUrl = getIAMUXAppsUrl;

var getIAMUXChangePasswordUrl = function getIAMUXChangePasswordUrl(location, tenantId) {
  var baseAddress = getIAMUXBaseAddress(location, tenantId);
  baseAddress.pathname = '/ChangePassword.aspx';
  return baseAddress.toString();
};

exports.getIAMUXChangePasswordUrl = getIAMUXChangePasswordUrl;

var getIAMUXTermsOfUseUrl = function getIAMUXTermsOfUseUrl(location, tenantId) {
  var baseAddress = getIAMUXBaseAddress(location, tenantId);
  baseAddress.pathname = '/responsive/TermsOfUse';
  return baseAddress.toString();
};

exports.getIAMUXTermsOfUseUrl = getIAMUXTermsOfUseUrl;

function getIAMUXBaseAddress(locationOrParams, tenantIdParam) {
  var _ref = locationOrParams && isIGetIAMUXUrlParams(locationOrParams) ? locationOrParams : {
    location: locationOrParams,
    tenantId: tenantIdParam || '',
    loginHint: ''
  },
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? window.location : _ref$location,
      tenantId = _ref.tenantId,
      loginHint = _ref.loginHint,
      optInApp = _ref.optInApp;

  var environment = (0, _determineEnvironment.determineEnvironment)(location);
  var protocolPrefix = 'https://';
  var iamuxBaseAddressOverrideEndpoint = (0, _overrideSettings.getOverrideSetting)('iamuxBaseAddressEndpoint');
  var url;

  if (iamuxBaseAddressOverrideEndpoint) {
    var _context;

    url = new _url.default((0, _concat.default)(_context = "".concat(protocolPrefix)).call(_context, iamuxBaseAddressOverrideEndpoint));
  } else {
    switch (environment) {
      case _determineEnvironment.EnvironmentType.localhost:
      case _determineEnvironment.EnvironmentType.PPE:
        url = new _url.default("".concat(protocolPrefix, "account.activedirectory-ppe.windowsazure.com"));
        break;

      case _determineEnvironment.EnvironmentType.TIP:
        url = new _url.default("".concat(protocolPrefix, "account-tip.activedirectory.windowsazure.com"));
        break;

      case _determineEnvironment.EnvironmentType.PROD:
        url = new _url.default("".concat(protocolPrefix, "account.activedirectory.windowsazure.com"));
        break;

      case _determineEnvironment.EnvironmentType.AR:
        url = new _url.default("".concat(protocolPrefix, "account.activedirectory.windowsazure.us"));
        break;

      case _determineEnvironment.EnvironmentType.USSEC:
        url = new _url.default("".concat(protocolPrefix, "account.aad.microsoft.scloud"));
        break;

      case _determineEnvironment.EnvironmentType.USNAT:
        url = new _url.default("".concat(protocolPrefix, "account.aad.eaglex.ic.gov"));
        break;

      default:
        url = new _url.default("".concat(protocolPrefix, "account.activedirectory-ppe.windowsazure.com"));
    }
  }

  if (tenantId) {
    url.searchParams.set('tenantId', tenantId);
  }

  if (loginHint) {
    url.searchParams.set('login_hint', loginHint);
  }

  if (optInApp) {
    url.searchParams.set('optIn', optInApp);
  }

  return url;
}

var getApiPrefix = function getApiPrefix(isBackend) {
  return isBackend ? 'api.' : '';
};

var getUrlForApp = function getUrlForApp(location, appKey, isBackend) {
  var _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17, _context18, _context19, _context20, _context21, _context22;

  var key = appKey;

  if (appKey === AppKeys.apps) {
    key = 'myapplications';
  }

  key = key.toLowerCase();
  var prefix = getApiPrefix(isBackend);
  var environment = (0, _determineEnvironment.determineEnvironment)(location);
  var protocolPrefix = 'https://';
  var urlSuffix = (0, _overrideSettings.getOverrideSetting)('appUrlSuffix');

  if (urlSuffix) {
    var _context2, _context3, _context4;

    return new _url.default((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(protocolPrefix)).call(_context4, prefix)).call(_context3, key)).call(_context2, urlSuffix));
  }

  switch (environment) {
    case _determineEnvironment.EnvironmentType.localhost:
      return new _url.default(process.env.APP_LOCALHOST_URL || 'http://localhost:3000');

    case _determineEnvironment.EnvironmentType.PPE:
      return new _url.default((0, _concat.default)(_context5 = (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "".concat(protocolPrefix)).call(_context7, prefix)).call(_context6, key)).call(_context5, process.env.APP_PPE_URL_SUFFIX));

    case _determineEnvironment.EnvironmentType.TIP:
      return new _url.default((0, _concat.default)(_context8 = (0, _concat.default)(_context9 = (0, _concat.default)(_context10 = "".concat(protocolPrefix)).call(_context10, prefix)).call(_context9, key)).call(_context8, process.env.APP_TIP_URL_SUFFIX));

    case _determineEnvironment.EnvironmentType.PROD:
      return new _url.default((0, _concat.default)(_context11 = (0, _concat.default)(_context12 = (0, _concat.default)(_context13 = "".concat(protocolPrefix)).call(_context13, prefix)).call(_context12, key)).call(_context11, process.env.APP_PROD_URL_SUFFIX));

    case _determineEnvironment.EnvironmentType.AR:
      return new _url.default((0, _concat.default)(_context14 = (0, _concat.default)(_context15 = (0, _concat.default)(_context16 = "".concat(protocolPrefix)).call(_context16, prefix)).call(_context15, key)).call(_context14, process.env.APP_AR_URL_SUFFIX));

    case _determineEnvironment.EnvironmentType.USSEC:
      return new _url.default((0, _concat.default)(_context17 = (0, _concat.default)(_context18 = (0, _concat.default)(_context19 = "".concat(protocolPrefix)).call(_context19, prefix)).call(_context18, key)).call(_context17, process.env.APP_USSEC_URL_SUFFIX));

    case _determineEnvironment.EnvironmentType.USNAT:
      return new _url.default((0, _concat.default)(_context20 = (0, _concat.default)(_context21 = (0, _concat.default)(_context22 = "".concat(protocolPrefix)).call(_context22, prefix)).call(_context21, key)).call(_context20, process.env.APP_USNAT_URL_SUFFIX));
  }
};
/**
 * Gets the base ajax options for making IAMUX ajax requests.
 */


exports.getUrlForApp = getUrlForApp;

var getIAMUXRequestOptions = function getIAMUXRequestOptions() {
  return {
    hasXssiResponse: true,
    audience: process.env.APP_ADAL_IAMUX_CLIENT_ID,
    sendSessionId: false,
    // IAMUX has logger lived sessions
    withCredentials: true,
    setResponseRequestId: true
  };
}; // TODO: use Omit


exports.getIAMUXRequestOptions = getIAMUXRequestOptions;

function isIGetIAMUXUrlParams(obj) {
  return obj.origin === undefined;
}